<div *ngIf="!isLoading">
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="usrForm">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Informações básicas</span>
			</div>
			<div class="d-f line">
				<mat-form-field class="mr-xxxs col-1" title="CPF" appearance="outline">
					<mat-label>CPF</mat-label>
					<input
						type="text"
						matInput
						mask="000.000.000-00"
						placeholder="CPF"
						formControlName="cpf"
						id="spc-{{ inputId }}"
					/>
					<mat-error
						*ngIf="
							usrForm.get('cpf')?.hasError('pattern') &&
							!usrForm.get('cpf')?.hasError('required') &&
							!usrForm.get('cpf')?.hasError('minlength')
						"
					>
						Digite um CPF válido
					</mat-error>
					<mat-error
						*ngIf="
							usrForm.get('cpf')?.hasError('minlength') &&
							!usrForm.get('cpf')?.hasError('pattern') &&
							!usrForm.get('cpf')?.hasError('required')
						"
					>
						CPF já cadastrado
					</mat-error>
					<mat-error *ngIf="usrForm.get('cpf')?.hasError('required')">
						É necessário digitar o cpf
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="mr-xxxs col-2 mob-va"
					title="Nome completo"
					appearance="outline"
				>
					<mat-label>Nome Completo</mat-label>
					<input
						type="text"
						matInput
						placeholder="Nome completo"
						formControlName="name"
						id="snf-{{ inputId }}"
					/>
					<mat-error *ngIf="usrForm.get('name')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field
					class="mr-xxxs col-1"
					title="Telefone"
					appearance="outline"
				>
					<mat-label>Telefone</mat-label>
					<input
						type="text"
						matInput
						placeholder="Telefone"
						formControlName="phone"
						id="spp-{{ inputId }}"
						mask="{{ phoneMask(usrForm.get('phone')?.value) }}"
					/>
					<mat-error
						*ngIf="
							usrForm.get('phone')?.hasError('pattern') &&
							!usrForm.get('phone')?.hasError('required')
						"
					>
						Digite um telefone válido
					</mat-error>
					<mat-error *ngIf="usrForm.get('phone')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="mr-xxxs col-2 mob-va"
					title="E-mail"
					appearance="outline"
				>
					<mat-label>E-mail</mat-label>
					<input
						type="text"
						matInput
						placeholder="E-mail"
						formControlName="email"
						id="sne-{{ inputId }}"
						(blur)="onEmailBlur()"
					/>
					<mat-error
						*ngIf="
							usrForm.get('email')?.hasError('email') &&
							!usrForm.get('email')?.hasError('required')
						"
					>
						Digite um email válido
					</mat-error>
					<mat-error
						*ngIf="
							usrForm.get('email')?.hasError('minlength') &&
							!usrForm.get('email')?.hasError('pattern') &&
							!usrForm.get('email')?.hasError('required')
						"
					>
						Email já cadastrado
					</mat-error>
					<mat-error *ngIf="usrForm.get('email')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="prsForm">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Dados Pessoais</span>
			</div>
			<div class="d-f line">
				<mat-form-field class="mr-xxxs col-1" appearance="outline">
					<mat-label>Data de nascimento</mat-label>
					<input
						matInput
						placeholder="Data de nascimento"
						formControlName="birthday"
						id="sbd-{{ inputId }}"
						[matDatepicker]="bpicker"
					/>
					<mat-datepicker-toggle matSuffix [for]="bpicker">
						<mat-icon
							matDatepickerToggleIcon
							svgIcon="sanus-calendar-blue"
						></mat-icon>
					</mat-datepicker-toggle>
					<mat-datepicker #bpicker></mat-datepicker>
					<mat-error *ngIf="prsForm.get('birthday')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field class="mr-xxxs col-2" appearance="outline">
					<mat-label>Nome da mãe</mat-label>
					<input
						type="text"
						matInput
						placeholder="Nome completo"
						formControlName="mothers_name"
						id="smn-{{ inputId }}"
					/>
					<mat-error *ngIf="prsForm.get('mothers_name')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field class="mr-xxxs col-1" appearance="outline">
					<mat-label>Estado civil</mat-label>
					<mat-select formControlName="marital_status">
						<mat-option
							*ngFor="let maritalStatus of maritalStatusList"
							[value]="maritalStatus.value"
							(click)="onMaritalStatusChange(maritalStatus.value)"
						>
							{{ maritalStatus.label }}
						</mat-option>
					</mat-select>
					<mat-error
						*ngIf="prsForm.get('marital_status')?.hasError('required')"
					>
						Campo obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="mr-xxxs col-1"
					title="Data de casamento"
					appearance="outline"
				>
					<mat-label>Data de Casamento</mat-label>
					<input
						matInput
						placeholder="Data de casamento"
						formControlName="marriageDate"
						id="smd-{{ inputId }}"
						[matDatepicker]="pickerc"
					/>
					<mat-datepicker-toggle matSuffix [for]="pickerc">
						<mat-icon
							matDatepickerToggleIcon
							svgIcon="sanus-calendar-blue"
						></mat-icon>
					</mat-datepicker-toggle>
					<mat-datepicker #pickerc></mat-datepicker>
					<mat-error *ngIf="prsForm.get('marriageDate')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field class="mr-xxxs col-1" appearance="outline">
					<mat-label>Sexo</mat-label>
					<mat-select formControlName="gender">
						<mat-option *ngFor="let gender of genders" [value]="gender">
							{{ gender }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="prsForm.get('gender')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="addForm">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">
					Endereço do beneficiário
				</span>
			</div>
			<div class="d-f ai-c line">
				<mat-form-field class="mr-xs col-1" appearance="outline">
					<mat-label>CEP</mat-label>
					<input
						type="text"
						matInput
						placeholder="CEP"
						mask="00000-000"
						formControlName="postal_code"
						id="spc-{{ inputId }}"
						(blur)="onCepBlur()"
					/>
					<mat-error
						*ngIf="
							addForm.get('postal_code')?.hasError('pattern') &&
							!addForm.get('postal_code')?.hasError('required')
						"
					>
						Digite um CEP válido
					</mat-error>
					<mat-error *ngIf="addForm.get('postal_code')?.hasError('required')">
						É necessário digitar o CEP
					</mat-error>
				</mat-form-field>
				<a
					class="pb-xxxs"
					href="https://buscacepinter.correios.com.br/app/endereco/index.php"
					target="_blank"
				>
					Não sei o CEP
				</a>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field class="col-2" appearance="outline">
					<mat-label>Endereço</mat-label>
					<input
						type="text"
						matInput
						placeholder="Endereço"
						formControlName="street"
						id="sph-{{ inputId }}"
					/>
					<mat-error *ngIf="addForm.get('street')?.hasError('required')">
						O endereço é obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field class="ml-xxxs mr-xxxs col-1" appearance="outline">
					<mat-label>Número</mat-label>
					<input
						type="text"
						matInput
						placeholder="Número"
						formControlName="number"
						id="san-{{ inputId }}"
					/>
					<mat-error *ngIf="addForm.get('number')?.hasError('required')">
						O número é obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field class="col-1 dyn" appearance="outline">
					<mat-label>Complemento (opcional)</mat-label>
					<input
						type="text"
						matInput
						placeholder="Complemento (opcional)"
						formControlName="complement"
						id="snc-{{ inputId }}"
					/>
				</mat-form-field>
				<mat-form-field class="ml-xxxs col-1 dyn" appearance="outline">
					<mat-label>Bairro</mat-label>
					<input
						type="text"
						matInput
						placeholder="Bairro"
						formControlName="neighborhood"
						id="san-{{ inputId }}"
					/>
					<mat-error *ngIf="addForm.get('neighborhood')?.hasError('required')">
						O bairro é obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field class="ml-xxxs mr-xxxs col-1 dyn" appearance="outline">
					<mat-label>Estado</mat-label>
					<mat-select formControlName="state">
						<mat-option
							*ngFor="let s of uf"
							[value]="s.uf"
							(click)="onUfChange(s.id, 'address')"
						>
							{{ s.label }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>

			<div class="d-f mt-xxs line">
				<mat-spinner diameter="20" *ngIf="isLoadingCities"></mat-spinner>
				<mat-form-field
					class="col-1"
					appearance="outline"
					*ngIf="!isLoadingCities"
				>
					<mat-label>Cidade</mat-label>
					<input
						type="text"
						matInput
						placeholder="Cidade"
						formControlName="city"
						id="sph-{{ inputId }}"
						*ngIf="!auxStateForm"
					/>
					<mat-select formControlName="city" *ngIf="auxStateForm">
						<mat-option [value]="null">Cidade</mat-option>
						<mat-option *ngFor="let city of cities" [value]="city">
							{{ city }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>
	</div>

	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="prfForm">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Dados profissionais</span>
			</div>
			<div class="d-f line">
				<mat-form-field class="mr-xxxs col-1" appearance="outline">
					<mat-label>Data de admissão</mat-label>
					<input
						matInput
						placeholder="Data de admissão"
						formControlName="admission_date"
						id="sad-{{ inputId }}"
						[matDatepicker]="apicker"
					/>
					<mat-datepicker-toggle matSuffix [for]="apicker">
						<mat-icon
							matDatepickerToggleIcon
							svgIcon="sanus-calendar-blue"
						></mat-icon>
					</mat-datepicker-toggle>
					<mat-datepicker #apicker></mat-datepicker>
					<mat-error
						*ngIf="prfForm.get('admission_date')?.hasError('required')"
					>
						Campo obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field class="mr-xxxs col-1" appearance="outline">
					<mat-label>Data de inclusão no plano</mat-label>
					<input
						matInput
						placeholder="Data de inclusão no plano"
						formControlName="plan_inclusion_date"
						id="sid-{{ inputId }}"
						[matDatepicker]="ipicker"
					/>
					<mat-datepicker-toggle matSuffix [for]="ipicker">
						<mat-icon
							matDatepickerToggleIcon
							svgIcon="sanus-calendar-blue"
						></mat-icon>
					</mat-datepicker-toggle>
					<mat-datepicker #ipicker></mat-datepicker>
					<mat-error
						*ngIf="prfForm.get('plan_inclusion_date')?.hasError('required')"
					>
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field
					class="mr-xxxs col-2"
					title="Cargo"
					appearance="outline"
				>
					<mat-label>Cargo</mat-label>
					<mat-select formControlName="position_id">
						<mat-option *ngFor="let pos of positions" [value]="pos.id">
							{{ pos.name }}{{ pos.city || pos.state ? ' - ' : ''
							}}{{ pos.city ? pos.city : ''
							}}{{ pos.city && pos.state ? '-' : ''
							}}{{ pos.state ? pos.state : '' }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="prfForm.get('position_id')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field class="mr-xxxs col-1" appearance="outline">
					<mat-label>Salário</mat-label>
					<input
						type="text"
						matInput
						placeholder="Salário"
						formControlName="wage"
						id="sbw-{{ inputId }}"
					/>
				</mat-form-field>
				<mat-form-field class="mr-xxxs col-1" appearance="outline">
					<mat-label>Matrícula</mat-label>
					<input
						type="text"
						matInput
						placeholder="Matrícula"
						formControlName="registration"
						id="sbr-{{ inputId }}"
					/>
					<mat-error *ngIf="prfForm.get('registration')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="wAddForm">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Local de trabalho</span>
			</div>

			<div class="d-f line">
				<mat-form-field class="mr-xxxs col-1 dyn" appearance="outline">
					<mat-label>Estado</mat-label>
					<mat-select formControlName="state">
						<mat-option
							*ngFor="let state of uf"
							[value]="state.uf"
							(click)="onUfChange(state.id, 'work')"
						>
							{{ state.label }}
						</mat-option>
					</mat-select>
				</mat-form-field>

				<mat-spinner diameter="20" *ngIf="isLoadingWorkCities"></mat-spinner>

				<mat-form-field
					class="col-1"
					appearance="outline"
					*ngIf="!isLoadingWorkCities"
				>
					<mat-label>Cidade</mat-label>
					<input
						type="text"
						matInput
						placeholder="Cidade"
						formControlName="city"
						id="sph-{{ inputId }}"
						*ngIf="!auxStateForm2"
					/>
					<mat-select formControlName="city" *ngIf="auxStateForm2">
						<mat-option [value]="null">Cidade</mat-option>
						<mat-option *ngFor="let city of auxCities" [value]="city">
							{{ city }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div class="d-f jc-fe mb-huge">
		<button
			mat-flat-button
			color="primary"
			[disabled]="disabledSaveBtn()"
			(click)="onSubmit()"
		>
			Salvar
		</button>
	</div>
</div>
<div class="d-f jc-c ai-c w-100 mt-giant loader" *ngIf="isLoading">
	<mat-spinner diameter="20"></mat-spinner>
</div>
